import React from 'react';

import ArrayContainer from '../Controls/ArrayContainer/ArrayContainer';
import Button from '../Controls/Button/Button';
import styles from './ConventionCreator.module.css';
import NamingConvention from './NamingConvention';

const ConventionCreator = ({
    namingConventions,
    NAMING_CONVENTION_FIELD,
    title,
    addNewNamingConvention,
    updateConventionsArray,
    removeItem,
    filteredOptions,
    hideBorder = false,
    disabled = false
}) => {
    return (
        <div className={`${styles.convention} ${hideBorder ? styles.hideBorder : ''}`}>
            <h5>{title}</h5>
            {namingConventions.value.map((namingConvention, index) => {
                return (
                    <ArrayContainer
                        key={NAMING_CONVENTION_FIELD.ID + index}
                        header="Convention"
                        topSpace={false}
                        remove={() => !disabled && removeItem(NAMING_CONVENTION_FIELD.ID, index)}>
                        <NamingConvention
                            namingConvention={namingConvention}
                            changedFunc={(fId, v) => updateConventionsArray(index, NAMING_CONVENTION_FIELD.ID, fId, v)}
                            filteredOptions={filteredOptions}
                            disabled={disabled}
                        />
                    </ArrayContainer>
                );
            })}
            <Button
                style={{ marginTop: `${namingConventions.value.length === 0 ? '10px' : '0'}` }}
                disabled={disabled}
                onClick={() => addNewNamingConvention(NAMING_CONVENTION_FIELD.ID)}>
                + Add {title} Naming Convention
            </Button>
            {namingConventions.error && <div className={styles.errorText}>{namingConventions.error}</div>}
        </div>
    );
};

export default React.memo(ConventionCreator);
